type AuthenticationRecoveryListener = (required: boolean) => void;

const listeners: AuthenticationRecoveryListener[] = [];
let recoveryRequired = false;
let recoveryPromise: Promise<void> | null = null;
let resolveRecovery: (() => void) | null = null;
let rejectRecovery: ((reason?: any) => void) | null = null;

function notifyListeners() {
    listeners.slice().forEach(listener => listener(recoveryRequired));
}

export function subscribeAuthenticationRecovery(
    listener: AuthenticationRecoveryListener,
): () => void {
    listeners.push(listener);
    listener(recoveryRequired);
    return () => {
        const index = listeners.indexOf(listener);
        if (index >= 0) {
            listeners.splice(index, 1);
        }
    };
}

export function requestAuthenticationRecovery(): Promise<void> {
    if (!recoveryPromise) {
        recoveryRequired = true;
        recoveryPromise = new Promise<void>((resolve, reject) => {
            resolveRecovery = resolve;
            rejectRecovery = reject;
        });
        notifyListeners();
    }
    return recoveryPromise;
}

export function completeAuthenticationRecovery() {
    const resolve = resolveRecovery;
    recoveryPromise = null;
    resolveRecovery = null;
    rejectRecovery = null;
    recoveryRequired = false;
    notifyListeners();
    if (resolve) {
        resolve();
    }
}

export function cancelAuthenticationRecovery() {
    const reject = rejectRecovery;
    recoveryPromise = null;
    resolveRecovery = null;
    rejectRecovery = null;
    recoveryRequired = false;
    notifyListeners();
    if (reject) {
        reject(new Error('Autenticação cancelada pelo usuário'));
    }
}

export function discardAuthenticationRecovery() {
    recoveryPromise = null;
    resolveRecovery = null;
    rejectRecovery = null;
    recoveryRequired = false;
    notifyListeners();
}
